import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _size from "lodash/size";
import _each from "lodash/each";
import _has from "lodash/has";
import _isEmpty from "lodash/isEmpty";
import moment from 'moment';
import { recategorizeTransaction, resetTransactions, createMerchantCategoryRule, getTransactionsSpendingMonthly, getCategoryWindowRollups, editTransaction } from "../actions/yodlee";
import { getTransactionRollupsByCategory, getTransactionData, getMonthsByCategoryForRollupsAfterMerchantCategoryRule, getViewFilter } from "../selectors/yodlee";
import { isSpendingTransactionCategory } from "../utils/yodlee";
import { DATE_FORMAT } from "../constants";
export default (function (_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return function (next) {
    return function (action) {
      if (!process.browser) return next(action);

      var _getState = getState(),
          identity = _getState.identity; // When we recategorize a transaction we need to fetch new category rollups


      if (action.type === recategorizeTransaction.SUCCESS_TYPE) {
        var _previousCategoryData, _nextCategoryData$mon;

        var _action$meta = action.meta,
            category = _action$meta.category,
            previousCategory = _action$meta.previousCategory,
            date = _action$meta.date;
        var startOfMonth = moment(date).startOf('month').format(DATE_FORMAT.STANDARD);
        var previousCategoryData = getTransactionData(identity, {
          category: previousCategory
        });
        var nextCategoryData = getTransactionData(identity, {
          category: category
        });
        var categoryChangedFromOrToSpendingCategory = isSpendingTransactionCategory(category) && !isSpendingTransactionCategory(previousCategory) || isSpendingTransactionCategory(previousCategory) && !isSpendingTransactionCategory(category); // fetch EVERYTHING rollup if any transactions were recategorized to/from spending

        if (categoryChangedFromOrToSpendingCategory) {
          dispatch(getTransactionsSpendingMonthly({
            dayInEndMonth: startOfMonth,
            dayInStartMonth: startOfMonth
          }));
          var viewFilter = getViewFilter(identity); // Fetch new rollups for non-category filters (e.g. merchant)

          if (!_isEmpty(viewFilter) && !_has(viewFilter, 'category')) {
            dispatch(getTransactionsSpendingMonthly({
              dayInEndMonth: startOfMonth,
              dayInStartMonth: startOfMonth,
              filter: viewFilter
            }));
          }
        }

        if ((previousCategoryData === null || previousCategoryData === void 0 ? void 0 : (_previousCategoryData = previousCategoryData.monthRollups) === null || _previousCategoryData === void 0 ? void 0 : _previousCategoryData[startOfMonth]) || (nextCategoryData === null || nextCategoryData === void 0 ? void 0 : (_nextCategoryData$mon = nextCategoryData.monthRollups) === null || _nextCategoryData$mon === void 0 ? void 0 : _nextCategoryData$mon[startOfMonth])) {
          dispatch(getCategoryWindowRollups({
            startDate: startOfMonth,
            endDate: moment(date).endOf('month').format(DATE_FORMAT.STANDARD)
          }));
        }
      } // When we edit a transaction we need to fetch new category rollups


      if (action.type === editTransaction.SUCCESS_TYPE) {
        var _previousCategoryData3, _previousCategoryData4, _nextCategoryData$mon2, _nextCategoryData$mon3;

        var _action$meta2 = action.meta,
            _category = _action$meta2.category,
            _date = _action$meta2.date,
            _previousCategory = _action$meta2.previousCategory,
            previousDate = _action$meta2.previousDate;
        var startOfPreviousDateMonth = moment(previousDate).startOf('month').format(DATE_FORMAT.STANDARD);

        var _startOfMonth = moment(_date).startOf('month').format(DATE_FORMAT.STANDARD);

        var hasDateChangedMonth = startOfPreviousDateMonth !== _startOfMonth;

        var _previousCategoryData2 = getTransactionData(identity, {
          category: _previousCategory
        });

        var _nextCategoryData = getTransactionData(identity, {
          category: _category
        }); // if the category didn't change, then the amount or date would have changed
        // so we only care if these are spending related. If the category did change,
        // then we only care if the old or new categories are spending related because
        // the spending monthly would change


        if (isSpendingTransactionCategory(_category) || isSpendingTransactionCategory(_previousCategory)) {
          dispatch(getTransactionsSpendingMonthly({
            dayInEndMonth: _startOfMonth,
            dayInStartMonth: _startOfMonth
          }));

          if (hasDateChangedMonth) {
            dispatch(getTransactionsSpendingMonthly({
              dayInEndMonth: startOfPreviousDateMonth,
              dayInStartMonth: startOfPreviousDateMonth
            }));
          }

          var _viewFilter = getViewFilter(identity); // Fetch new rollups for non-category filters (e.g. merchant)


          if (!_isEmpty(_viewFilter) && !_has(_viewFilter, 'category')) {
            dispatch(getTransactionsSpendingMonthly({
              dayInEndMonth: _startOfMonth,
              dayInStartMonth: _startOfMonth,
              filter: _viewFilter
            }));

            if (hasDateChangedMonth) {
              dispatch(getTransactionsSpendingMonthly({
                dayInEndMonth: startOfPreviousDateMonth,
                dayInStartMonth: startOfPreviousDateMonth,
                filter: _viewFilter
              }));
            }
          }
        }

        if ((_previousCategoryData2 === null || _previousCategoryData2 === void 0 ? void 0 : (_previousCategoryData3 = _previousCategoryData2.monthRollups) === null || _previousCategoryData3 === void 0 ? void 0 : _previousCategoryData3[_startOfMonth]) || (_previousCategoryData2 === null || _previousCategoryData2 === void 0 ? void 0 : (_previousCategoryData4 = _previousCategoryData2.monthRollups) === null || _previousCategoryData4 === void 0 ? void 0 : _previousCategoryData4[startOfPreviousDateMonth]) || (_nextCategoryData === null || _nextCategoryData === void 0 ? void 0 : (_nextCategoryData$mon2 = _nextCategoryData.monthRollups) === null || _nextCategoryData$mon2 === void 0 ? void 0 : _nextCategoryData$mon2[_startOfMonth]) || (_nextCategoryData === null || _nextCategoryData === void 0 ? void 0 : (_nextCategoryData$mon3 = _nextCategoryData.monthRollups) === null || _nextCategoryData$mon3 === void 0 ? void 0 : _nextCategoryData$mon3[startOfPreviousDateMonth])) {
          dispatch(getCategoryWindowRollups({
            startDate: _startOfMonth,
            endDate: moment(_date).endOf('month').format(DATE_FORMAT.STANDARD)
          }));

          if (hasDateChangedMonth) {
            dispatch(getCategoryWindowRollups({
              startDate: startOfPreviousDateMonth,
              endDate: moment(previousDate).endOf('month').format(DATE_FORMAT.STANDARD)
            }));
          }
        }
      }

      if (action.type === createMerchantCategoryRule.SUCCESS_TYPE) {
        var _action$meta3 = action.meta,
            transactionId = _action$meta3.transactionId,
            canonicalMerchantName = _action$meta3.canonicalMerchantName,
            newCategory = _action$meta3.category,
            _previousCategory2 = _action$meta3.previousCategory;
        var monthsByCategory = getMonthsByCategoryForRollupsAfterMerchantCategoryRule(identity, {
          transactionId: transactionId,
          canonicalMerchantName: canonicalMerchantName,
          category: newCategory,
          previousCategory: _previousCategory2
        });

        var _viewFilter2 = getViewFilter(identity); // fetch updated rollups for all categories that had a transaction recategorized


        _each(Object.keys(monthsByCategory), function (category) {
          var _monthsByCategory$cat = monthsByCategory[category],
              dayInStartMonth = _monthsByCategory$cat.dayInStartMonth,
              dayInEndMonth = _monthsByCategory$cat.dayInEndMonth;
          dispatch(getTransactionsSpendingMonthly({
            dayInEndMonth: dayInEndMonth,
            dayInStartMonth: dayInStartMonth,
            filter: {
              category: category
            }
          })); // fetch EVERYTHING rollup if any transactions were recategorized to/from spending

          if (!isSpendingTransactionCategory(category)) {
            dispatch(getTransactionsSpendingMonthly({
              dayInEndMonth: dayInEndMonth,
              dayInStartMonth: dayInStartMonth
            }));

            if (!_isEmpty(_viewFilter2) && !_has(_viewFilter2, 'category')) {
              dispatch(getTransactionsSpendingMonthly({
                dayInEndMonth: dayInEndMonth,
                dayInStartMonth: dayInStartMonth,
                filter: _viewFilter2
              }));
            }
          }
        });
      } // When we reset transactions, and if we already have categoryRollups, they are now stale,
      // so we must fetch new ones.


      if (action.type === resetTransactions.getType()) {
        var categoryRollups = getTransactionRollupsByCategory(identity);

        if (_size(categoryRollups) > 0) {
          dispatch(getCategoryWindowRollups({
            startDate: moment().startOf('month').format(DATE_FORMAT.STANDARD),
            endDate: moment().endOf('month').format(DATE_FORMAT.STANDARD)
          }));
        }
      }

      var returnValue = next(action);
      return returnValue;
    };
  };
});